import api from "app/api";
import { Options } from "common";
import { dragDropNew, groupEdit } from "features/events/Editor/eventEditorApi";
import { EventItem } from "features/events/eventApi";

export interface EventGroupItem {
  id: number;
  boat_id: number;
  duration: number;
  start_time: string;
  number_of_places?: number;
  number_of_online_places?: number;
  places_tolerance?: number;
  closed?: boolean;
  online_closed?: boolean;
  low_cancelled?: boolean;
  events?: EventItem[];
}

export type EventGroupOptions = Options<"boat_id">;

export function getEventGroupService(scope?: any) {
  return {
    ...api.getService<EventGroupItem, EventGroupItem, EventGroupOptions>(
      "event-groups",
      {
        scope,
        //params goes here
      }
    ),
    createItem: async (
      item: Partial<EventGroupItem>,
      onlyTrashed?: boolean
    ) => {
      return dragDropNew({
        ...(item as any),
      });
    },
  };
}

export function getGroupEventGroupService(scope?: any, eventGroupIds?: any) {
  return {
    ...api.getService<EventGroupItem>("event-groups", {
      scope,
      //params goes here
    }),
    updateItem: async (
      id: number,
      item: Partial<EventGroupItem>,
      onlyTrashed?: boolean
    ) => {
      return groupEdit({
        ...item,
        event_group_ids: eventGroupIds,
      });
    },
  };
}
